import React from "react";
import { useState, useEffect, useReducer } from "react";
import "antd/dist/antd.css";
import { Link } from "react-router-dom";
/* import "./styles-for-new-dashboard.css"; */
import "../NewDashboard/styles-for-new-dashboard.css";
import mainLogoSerpMaze from "./Telescope-frontpage.png";
import { Spinner } from "react-bootstrap";

import {
  Container,
  Row,
  Col,
  Alert,
  OverlayTrigger,
  Tooltip,
  Button,
  ProgressBar,
  Badge,
} from "react-bootstrap";
import "../OnSiteScrapingPage/css-results-component-onsite-scraping-component.css";
import { Helmet } from "react-helmet-async";

import { PieChart } from "react-minimal-pie-chart";
import moment from "moment";

import {
  UserOutlined,
  PieChartOutlined,
  CaretDownOutlined,
  MonitorOutlined,
  RiseOutlined,
  DotChartOutlined,
  AreaChartOutlined,
  MailOutlined,
  MoreOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import {
  Dropdown,
  Space,
  message,
  Layout,
  Menu,
  Modal,
  Drawer,
  Card,
} from "antd";

const ReportPageFromInsideApp = (/* { email } */) => {
  const [isCustomerPaying, setIsCustomerPaying] = useState(false);
  const [selectedMednuItem, setSelectedMenuItem] = useState("Report");
  //FOR THE DRAWER:
  const [visible, setVisible] = useState(false);

  //ALL THE STATES BELOW NEEDED TO RENDER THE REPORT :

  const [email, setEmail] = useState();
  const [urlInput, setUrlInput] = useState("");
  const [arrayWithAllHInformation, setArrayWithAllHInformation] = useState();
  const [faviconFromWebsite, setFaviconFromWebsite] = useState("");
  const [h1Length, setH1Length] = useState();
  const [h2Length, setH2Length] = useState();
  const [h3Length, setH3Length] = useState();
  const [h4Length, setH4Length] = useState();
  const [h5Length, setH5Length] = useState();
  const [h6Length, setH6Length] = useState();
  const [imageSrcAndAltTexts, setImageSrcAndAltTexts] = useState();
  const [isHttpsSupported, setIsHttpsSupported] = useState();
  const [metaDescription, setMetaDescription] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [numberOfEmptyAltTexts, setNumberOfEmptyAltTexts] = useState();
  const [outGoingNoFollowLinks, setOutGoingNoFollowLinks] = useState();
  const [robotsTXTExists, setRobotsTXTExists] = useState(false);
  const [externalLinks, setExternalLinks] = useState();
  const [internalLinks, setInternalLinks] = useState();
  const [mostCommonKeywords, setMostCommonKeywords] = useState();
  const [sslInfo, setSslInfo] = useState({});
  const [overallSEOScore, setOverallSEOScore] = useState(0);
  const [numberOfSuccessTests, setNumberOfSuccessTests] = useState(0);
  const [numberOfFailedTests, setNumberOfFailedTests] = useState(0);
  const [timeRightNowForReport, setTimeRightNowForReport] = useState();
  const [historyOfReports, setHistoryOfReports] = useState();
  // UNTIL HERE //ALL THE STATES BELOW NEEDED TO RENDER THE REPORT.

  const [firstTimeUser, setFirstTimeUser] = useState("");

  //THESE 2 BELOW ARE SET WITHIN THE INITIAL FETCH ON MOUNT:
  const [SSLValidFrom, setSSLValidFrom] = useState("");
  const [SSLValidTo, setSSLValidTo] = useState("");
  // UNTIL HERE**********************

  const [showFullListOfHeadings, setShowFullListOfHeadings] = useState(false);
  const [showFullListOfImageAltTexts, setShowFullListOfImageAltTexts] =
    useState(false);
  const [showFullListOfKeywords, setShowFullListOfKeywords] = useState(false);
  const [showFullListOfInternalLinks, setShowFullListOfInternalLinks] =
    useState(false);
  const [showFullListOfExternalLinks, setShowFullListOfExternalLinks] =
    useState(false);
  const [
    showFullListOfOutgoingNoFollowLinks,
    setShowFullListOfOutgoingNoFollowLinks,
  ] = useState(false);

  const [metaTitleTest, setMetaTitleTest] = useState();

  const [arrayForEmailSendout, setArrayForEmailSendout] = useState();
  const [loading, setLoading] = useState(false);
  const [overallLoading, setOverallLoading] = useState(false);
  const [errorInFetching, setErrorInFetching] = useState(false);
  const [showHTagResults, setShowHTagResults] = useState(false);

  const [style, setStyle] = useState({});
  const [showCheckNowButton, setShowCheckNowButton] = useState(true);
  const [resultsFromFetchHasSucceded, setResultsFromFetchHasSucceded] =
    useState(false);

  const [progressBar, setProgressBar] = useState(0);
  const [hideInputField, setHideInputField] = useState(false);
  const [urlDoesNotExist, setUrlDoesNotExist] = useState(false);
  const [browserTimedOut, setBrowserTimedOut] = useState(false);

  const [value, setValue] = useState(0);

  const [numberOfWarningTests, setNumberOfWarningTests] = useState(0);

  //ALL STATES FOR REPORT ENDING HERE*******************************
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0); // NOT USING THIS ONE AT THE MOMENT. REACT WRITES THAT IT IS BEST NOT TO USE: https://reactjs.org/docs/hooks-faq.html
  const [reRender, setRerender] = useState(0);

  const { Header, Content, Footer, Sider } = Layout;

  //THESE ARE THE TOKENS BELOW :
  const token = window.localStorage.getItem("token");
  const token2 = token?.slice(1, -1);

  //THIS IS THE COMPONENT DID MOUNT****************************: (IT NOW INCLUDES THE "reRender" WHICH IS USED TO UPDATE COMPONENTS.)
  useEffect(() => {
    if (!token) {
      localStorage.clear();
      window.location.replace("/");
    }
    setOverallLoading(true); // TURNING ON LOADER HERE.
    fetchDataOnMount();
  }, [reRender]);

  //THIS IS THE FETCH DATA FUNCTION, THAT IE BEING CALLED ON COMPONENT DID MOUNT: *************************
  const fetchDataOnMount = async () => {
    const response = await fetch(process.env.REACT_APP_FETCH_REPORT_DATA, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token2}`,
      },
    });
    if (response.ok) {
      const data = await response.json();
      setOverallLoading(false); // TURNING OFF LOADER HERE.

      setFirstTimeUser(data?.firstTimeUser);
      setEmail(data?.email);
      setUrlInput(data?.website);
      setArrayWithAllHInformation(data?.arrayOfHTagElements);
      setFaviconFromWebsite(data?.favicon);
      setH1Length(data?.h1Length);
      setH2Length(data?.h2Length);
      setH3Length(data?.h3Length);
      setH4Length(data?.h4Length);
      setH5Length(data?.h5Length);
      setH6Length(data?.h6Length);
      setImageSrcAndAltTexts(data?.imagesSrcAndAltTexts);
      setIsHttpsSupported(data?.isHttpsSupported);
      setMetaDescription(data?.metaDescription);
      setMetaTitle(data?.metaTitle);
      setNumberOfEmptyAltTexts(data?.numberOfEmptyAltTexts);
      setOutGoingNoFollowLinks(data?.outGoingNoFollowLinks);
      setRobotsTXTExists(data?.robotsTXTExists);
      setExternalLinks(data?.sortedExternalLinks);
      setInternalLinks(data?.sortedInternalLinks);
      setMostCommonKeywords(data?.sortedKeywords);
      setSslInfo(data?.sslInfo);
      setOverallSEOScore(data?.overallSEOScore);
      setNumberOfSuccessTests(data?.numberOfSuccessfullTests);
      setNumberOfFailedTests(data?.numberOfFailedTests);
      setTimeRightNowForReport(data?.timeReportWasGenerated);
      setOverallSEOScore(data?.overallSEOScore);
      setNumberOfSuccessTests(data?.numberOfSuccessfullTests);
      setNumberOfFailedTests(data?.numberOfFailedTests);
      setTimeRightNowForReport(data?.timeReportWasGenerated);
      setHistoryOfReports(data?.historyOfReports);
      setIsCustomerPaying(data?.paymentInformation?.isCustomerPaying);

      const SSLValidFrom = moment(sslInfo?.validFrom).format("MMMM Do YYYY");
      const SSLValidTo = moment(sslInfo?.validTo).format("MMMM Do YYYY");
      setSSLValidFrom(SSLValidFrom);
      setSSLValidTo(SSLValidTo);
    }
  };

  const onClick = ({ key }) => {
    message.info(`Click on item ${key}`);
    setSelectedMenuItem({ key });
  };

  // sider and drawer toggle
  const [isToggled, setToggled] = useState(false);
  const toggleTrueFalse = () => setToggled(!isToggled);
  const onClose = () => {
    setToggled(false);
  };

  const logoutFunction = () => {
    console.log("log me out please ");
    localStorage.clear();
    window.location.replace("/");
  };

  const menu = (
    <Menu
      onClick={logoutFunction}
      items={[
        /*         {
          label: "My account",
          key: "1",
        }, */
        /* {
          label: "Billing",
          key: "2",
        }, */
        {
          label: (
            <span style={{ color: "red" }} onClick={logoutFunction}>
              Logout
            </span>
          ),
          key: "3",
        },
      ]}
    />
  );
  function getItem(label, key, icon, children) {
    return {
      key,
      icon,
      children,
      label,
    };
  }

  //THESE BELOW ONES ARE FOR THE ONCLICKS ON THE REPORT TO SEE MORE.
  const showHeadingsFunction = (e) => {
    setShowFullListOfHeadings(true);
  };

  const hideHeadingsFunction = (e) => {
    setShowFullListOfHeadings(false);
  };

  const hideImageAltTextsFunction = (e) => {
    setShowFullListOfImageAltTexts(false);
  };

  const showImageAltTextsFunction = (e) => {
    setShowFullListOfImageAltTexts(true);
  };

  const showFullListOfKeywordsFunction = (e) => {
    setShowFullListOfKeywords(true);
  };

  const hideFullListOfKeywordsFunction = (e) => {
    setShowFullListOfKeywords(false);
  };

  const showFullListOfInternalLinksFunction = (e) => {
    setShowFullListOfInternalLinks(true);
  };

  const hideFullListOfInternalLinksFunction = (e) => {
    setShowFullListOfInternalLinks(false);
  };

  const showFullListOfExternalLinksFunction = (e) => {
    setShowFullListOfExternalLinks(true);
  };

  const hideFullListOfExternalLinksFunction = (e) => {
    setShowFullListOfExternalLinks(false);
  };

  const showFullListOfOutgoingNoFollowLinksFunction = (e) => {
    setShowFullListOfOutgoingNoFollowLinks(true);
  };

  const hideFullListOfOutgoingNoFollowLinksFunction = (e) => {
    setShowFullListOfOutgoingNoFollowLinks(false);
  };

  const takeMetoSignUpFunction = () => {
    window.location.assign("/signup");
  };

  const takeMeToTheDashboardPage = () => {
    window.location.assign("/dashboard"); // THIS ONE NEEDS TO BE CHANGED LATER!
  };

  return (
    <Layout /* style={{ height: "100vh" }} */>
      <Drawer
        className="hideOnDesktop"
        bodyStyle={{ backgroundColor: "#001529", padding: "0" }}
        placement="left"
        closable={false}
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
      >
        <div className="sider-menu-and-bottom-package-div">
          <div
            className="logo"
            style={{ cursor: "pointer", display: "flex" }}
            onClick={takeMeToTheDashboardPage}
          >
            <img
              src={mainLogoSerpMaze}
              alt="SerpMaze Logo"
              style={{ width: "40px" }}
            />
            SerpMaze
          </div>
          <div>
            <Menu theme="dark" mode="inline" defaultSelectedKeys={["3"]}>
              <Menu.Item key="1">
                <span>Dashboard</span>
                <Link to="/dashboard" />
              </Menu.Item>

              <Menu.SubMenu title="Analysis" key="2">
                <Menu.Item key="3">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                    }}
                  >
                    <ArrowRightOutlined
                      style={{ fontSize: "0.8em", paddingRight: "1em" }}
                    />

                    <p>Tracked website</p>
                  </div>

                  <Link to="/report" />
                </Menu.Item>
                <Menu.Item key="4">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                    }}
                  >
                    <ArrowRightOutlined
                      style={{ fontSize: "0.8em", paddingRight: "1em" }}
                    />

                    <p>Competitors</p>
                  </div>
                  <Link to="/saved-reports" />
                </Menu.Item>
                <Menu.Item key="5">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                    }}
                  >
                    <ArrowRightOutlined
                      style={{ fontSize: "0.8em", paddingRight: "1em" }}
                    />

                    <p>Meta checker</p>
                  </div>
                  <Link to="/meta-checker" />
                </Menu.Item>
                <Menu.Item key="6">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                    }}
                  >
                    <ArrowRightOutlined
                      style={{ fontSize: "0.8em", paddingRight: "1em" }}
                    />

                    <p>Schema generator</p>
                  </div>
                  <Link to="/schema-generator" />
                </Menu.Item>
              </Menu.SubMenu>
              <Menu.SubMenu title="Monitoring" key="7">
                <Menu.Item key="7">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                    }}
                  >
                    <ArrowRightOutlined
                      style={{ fontSize: "0.8em", paddingRight: "1em" }}
                    />

                    <p>Keyword tracker</p>
                  </div>

                  <Link to="/keyword-tracker" />
                </Menu.Item>
              </Menu.SubMenu>
            </Menu>
          </div>
        </div>

        {isCustomerPaying === false ? (
          <div className="package-container">
            <span className="email">{email}</span>
            <span className="plan">Basic</span>
            {/* <span className="see-all-plans">See all plans ›</span> */}
          </div>
        ) : (
          <div className="package-container">
            <span className="email">{email}</span>
            <span className="plan">Professional</span>
            {/* <span className="see-all-plans">See all plans ›</span> */}
          </div>
        )}
      </Drawer>

      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        /* collapsed={isToggled} */
        onBreakpoint={(broken) => {
          setToggled(broken);
        }}
        className="hideOnMobile"
        /* onBreakpoint={(broken) => {
        console.log(broken);
      }}
      onCollapse={(collapsed, type) => {
        console.log(collapsed, type);
      }} */
      >
        <div className="sider-menu-and-bottom-package-div">
          <div
            className="logo"
            style={{ cursor: "pointer", display: "flex" }}
            onClick={takeMeToTheDashboardPage}
          >
            <img
              src={mainLogoSerpMaze}
              alt="SerpMaze Logo"
              style={{ width: "40px" }}
            />
            SerpMaze
          </div>
          <div>
            <Menu theme="dark" mode="inline" defaultSelectedKeys={["3"]}>
              <Menu.Item key="1">
                {/* <PieChartOutlined /> */}
                <span>Dashboard</span>
                <Link to="/dashboard" />
              </Menu.Item>

              <Menu.SubMenu title="Analysis" key="2">
                <Menu.Item key="3">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                    }}
                  >
                    <ArrowRightOutlined
                      style={{ fontSize: "0.8em", paddingRight: "1em" }}
                    />

                    <p>Tracked website</p>
                  </div>

                  <Link to="/report" />
                </Menu.Item>
                <Menu.Item key="4">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                    }}
                  >
                    <ArrowRightOutlined
                      style={{ fontSize: "0.8em", paddingRight: "1em" }}
                    />

                    <p>Competitors</p>
                  </div>
                  <Link to="/saved-reports" />
                </Menu.Item>
                <Menu.Item key="5">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                    }}
                  >
                    <ArrowRightOutlined
                      style={{ fontSize: "0.8em", paddingRight: "1em" }}
                    />

                    <p>Meta checker</p>
                  </div>
                  <Link to="/meta-checker" />
                </Menu.Item>
                <Menu.Item key="6">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                    }}
                  >
                    <ArrowRightOutlined
                      style={{ fontSize: "0.8em", paddingRight: "1em" }}
                    />

                    <p>Schema generator</p>
                  </div>
                  <Link to="/schema-generator" />
                </Menu.Item>
              </Menu.SubMenu>
              <Menu.SubMenu title="Monitoring" key="6">
                <Menu.Item key="7">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                    }}
                  >
                    <ArrowRightOutlined
                      style={{ fontSize: "0.8em", paddingRight: "1em" }}
                    />

                    <p>Keyword tracker</p>
                  </div>

                  <Link to="/keyword-tracker" />
                </Menu.Item>
              </Menu.SubMenu>
            </Menu>
          </div>
        </div>
        {isCustomerPaying === false ? (
          <div className="package-container">
            <span className="email">{email}</span>
            <span className="plan">Basic</span>
            {/* <span className="see-all-plans">See all plans ›</span> */}
          </div>
        ) : (
          <div className="package-container">
            <span className="email">{email}</span>
            <span className="plan">Professional</span>
            {/* <span className="see-all-plans">See all plans ›</span> */}
          </div>
        )}
      </Sider>

      {overallLoading === true ? (
        <Spinner
          style={{
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translateX(-50%, -50%)",
          }}
          animation="border"
          variant="success"
          className=""
        />
      ) : (
        <Layout className="site-layout">
          <Header className="site-layout-background" style={{ padding: 0 }}>
            {/* {React.createElement(
          isToggled ? "MenuUnfoldOutlined" : "MenuFoldOutlined",
          {
            className: "trigger",
            onClick: toggleTrueFalse,
          }
        )} */}
            <div className="header-page">
              <div className="header-in-top-nav">
                {/* // the button for the Drawer! */}
                <MoreOutlined
                  className="icon-in-the-top-left-for-opening-the-drawer"
                  type="primary"
                  onClick={() => {
                    setVisible(true);
                  }}
                />
                <span className="selected-menu-item-text-in-the-top-left">
                  {selectedMednuItem}
                </span>
              </div>
              <div className="user-name-section">
                <Dropdown overlay={menu}>
                  <a onClick={(e) => e.preventDefault()}>
                    <Space>
                      <UserOutlined className="anticon anticon-user icon" />
                      <span className="user-email">{email}</span>
                      <CaretDownOutlined className="anticon anticon-down down-icon" />
                    </Space>
                  </a>
                </Dropdown>
              </div>
            </div>
          </Header>
          <Content>
            <Container fluid className="">
              {" "}
              {/* BEFORE I HAD ADDED "mt-5 mb-5" HERE */}
              <Helmet>
                <meta charSet="utf-8" />
                <title>SerpMaze.com | Onsite SEO checker</title>
                <meta
                  name="description"
                  content="Check your onsite SEO in seconds. Get a step-by-step plan on how to improve your SEO."
                />
                <meta name="theme-color" content="#008f68" />

                <style>
                  {
                    "body { background: linear-gradient(180deg, #264068 100%, #50678b 100%) }"
                  }
                </style>

                <meta name="twitter:card" content="summary" />
                {/*         <meta name="twitter:site" content="@nytimesbits" />
        <meta name="twitter:creator" content="@nickbilton" /> */}
                <meta property="og:url" content="https://serpmaze.com/" />
                <meta
                  property="og:title"
                  content="SerpMaze.com | Onsite SEO checker"
                />
                <meta
                  property="og:description"
                  content="Check your onsite SEO in seconds. Get a step-by-step plan on how to improve your SEO."
                />
                {/*         <meta
          property="og:image"
          content="http://graphics8.nytimes.com/images/2011/12/08/technology/bits-newtwitter/bits-newtwitter-tmagArticle.jpg"
        /> */}
              </Helmet>
              <Row>
                <Col
                  className="results-col-onsite-scraping-results-component"
                  style={{ padding: "24px" }}
                >
                  {firstTimeUser === true ? (
                    <Card
                      style={{
                        borderRadius: "4px",
                      }}
                      className="first-time-user-card ant-card"
                      title={
                        <div className="card-title-body">
                          <span className="card-title">
                            Welcome! Start by setting up your account
                          </span>
                          <small>You need to set up your account first</small>
                        </div>
                      }
                      extra={
                        <div className="view-report-and-add-competitors-div"></div>
                      }
                      style={{
                        width: "100%",
                      }}
                    >
                      <div>
                        <p>
                          To start improving your SEO, you need to set up your
                          account first.
                        </p>
                        <p>
                          Once you have set up your account, you will be able to
                          see your website's SEO performance right here.
                        </p>
                        <div>
                          <span>
                            <button
                              style={{
                                background: "#28A745",
                                borderRadius: "4px",
                                border: "none",
                              }}
                              onClick={takeMeToTheDashboardPage}
                              data-cy="add-new-tracked-website"
                              type="button"
                              className="ant-btn ant-btn-primary first-time-user-button"
                              ant-click-animating-without-extra-node="false"
                            >
                              <span>Take me to the dashboard page</span>
                            </button>
                          </span>
                        </div>
                      </div>
                    </Card>
                  ) : (
                    <div className="wrapper-for-the-main-report-section">
                      {/* //OVERALL SEO CARD SECTION ****************************************************************/}

                      <div
                        className="d-flex common-seo-issues-outer-div"
                        style={{ background: "white" }}
                      >
                        <div className="top-card-box-onsite-result-component">
                          <h1
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {urlInput}
                          </h1>
                          <p
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            Report generated on {timeRightNowForReport}
                          </p>
                        </div>
                        <div className="summary-graph">
                          {/* PIE CHART BELOW *************************************************/}

                          <div className="summary-graph-wrapper">
                            <div className="summary-graph-total">
                              <PieChart
                                data={[
                                  {
                                    value: overallSEOScore,
                                    color:
                                      overallSEOScore >= 70
                                        ? "#28A745"
                                        : overallSEOScore >= 50 &&
                                          overallSEOScore <= 69
                                        ? "#FFC107"
                                        : "#DC3545",
                                  },
                                ]}
                                totalValue={100}
                                lineWidth={20}
                                label={({ dataEntry }) =>
                                  dataEntry.value + "/100"
                                }
                                labelStyle={{
                                  fontSize: "12px",
                                  fontFamily: "sans-serif",
                                  fill:
                                    overallSEOScore >= 70
                                      ? "#28A745"
                                      : overallSEOScore >= 50 &&
                                        overallSEOScore <= 69
                                      ? "#FFC107"
                                      : "#DC3545",
                                }}
                                labelPosition={0}
                                startAngle={270}
                              />
                            </div>
                            {/* // HIDING THE "IMPROVE YOUR SCORE NOW " BUTTON ON THIS REPORT PAGE */}
                            {/* <div className="register-modal">
                          <Button
                            onClick={takeMetoSignUpFunction}
                            variant="outline-danger"
                            size="lg"
                          >
                            <span>
                              Improve your score now{" "}
                              <i className="bi bi-arrow-up-right"></i>
                            </span>
                          </Button>
                        </div> */}
                          </div>
                          <div className="summary-graph-split">
                            <div className="progress-item failed">
                              <span className="progress-label">
                                <strong>{numberOfFailedTests} </strong>Failed
                              </span>
                              <div className="ant-progress-outer">
                                <ProgressBar
                                  className="ant-progress-inner"
                                  striped
                                  variant="danger"
                                  now={(100 / 8) * numberOfFailedTests}
                                />
                              </div>
                            </div>
                            <div className="progress-item warning">
                              <span className="progress-label">
                                <strong>{numberOfWarningTests} </strong>Warnings
                              </span>
                              <div className="ant-progress-outer">
                                <ProgressBar
                                  className="ant-progress-inner"
                                  striped
                                  variant="warning"
                                  now={(100 / 8) * numberOfWarningTests}
                                />
                              </div>
                            </div>
                            <div className="progress-item passed">
                              <span className="progress-label">
                                <strong>{numberOfSuccessTests} </strong>Passed
                              </span>
                              <div className="ant-progress-outer">
                                <ProgressBar
                                  className="ant-progress-inner"
                                  striped
                                  variant="success"
                                  now={(100 / 8) * numberOfSuccessTests}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* //COMMON SEO ISSUES ****************************************************************/}
                      <div
                        className="d-flex common-seo-issues-outer-div mt-3"
                        style={{ background: "white" }}
                      >
                        <div className="top-card-box-onsite-result-component">
                          <h4>Common SEO issues</h4>
                        </div>
                        <div className="common-seo-issues-inner-div">
                          {/*               <div className="title-div-and-middlemiddle-results-div"> */}

                          <div className="title-div-onsite-result-component">
                            {metaTitle?.length >= 30 &&
                            metaTitle?.length <= 65 ? (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "#4aac48",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Meta title test </strong>
                                  <small>Site passed meta title test</small>
                                </div>
                              </div>
                            ) : (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "red",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Meta title test </strong>
                                  <small>
                                    Site did not pass meta title test
                                  </small>
                                </div>
                              </div>
                            )}
                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    Meta titles are bits of HTML code in the
                                    header of a website. Having them, help
                                    search engines understand what the content
                                    of the page is about. Pages' titles are
                                    usually shown whenever a page appears in
                                    search engine results.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div">
                              {metaTitle?.length > 1 ? (
                                <small>
                                  This webpage is using a meta title tag{" "}
                                  <i
                                    style={{ color: "#4aac48" }}
                                    className="bi bi-hand-thumbs-up"
                                  ></i>
                                </small>
                              ) : (
                                <small>
                                  This webpage is not using a meta title tag{" "}
                                  <i
                                    style={{ color: "red" }}
                                    className="bi bi-hand-thumbs-down"
                                  ></i>
                                </small>
                              )}
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              <div>
                                <strong>Title: </strong>
                                <span style={{ fontSize: "14px" }}>
                                  {metaTitle}
                                </span>
                              </div>
                              <div style={{ display: "flex" }}>
                                <strong>Length:&nbsp;</strong>{" "}
                                <p style={{ margin: "0" }}>
                                  {metaTitle?.length} characters
                                </p>
                              </div>
                              <div className="meta-title-recommendations-div-onsite-scraping-results">
                                {metaTitle?.length <= 30 ? (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-danger"
                                    variant={"danger"}
                                  >
                                    Your meta title is too short. Recommended
                                    30-65 characters.
                                  </Alert>
                                ) : metaTitle?.length >= 65 ? (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-danger"
                                    variant={"danger"}
                                  >
                                    Your meta title is too long. Recommended is
                                    30-65 characters.
                                  </Alert>
                                ) : (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-success"
                                    variant={"success"}
                                  >
                                    Your meta title is between 30 - 65
                                    characters which is the recommended length.
                                    Good job 💪
                                  </Alert>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* </div> */}
                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  Meta titles are bits of HTML code in the
                                  header of a website. Having them, help search
                                  engines understand what the content of the
                                  page is about. Pages' titles are usually shown
                                  whenever a page appears in search engine
                                  results.
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                            </OverlayTrigger>
                          </div>
                        </div>
                        {/* LINE BREAK: */}
                        <div className="top-card-box-onsite-result-component"></div>

                        {/* META DESCRIPTION : ************************************************************* */}
                        <div className="common-seo-issues-inner-div">
                          {/*               <div className="title-div-and-middlemiddle-results-div"> */}
                          <div className="title-div-onsite-result-component">
                            {metaDescription?.length >= 120 &&
                            metaDescription?.length <= 160 ? (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "#4aac48",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Meta description test </strong>
                                  <small>
                                    Site passed meta description test
                                  </small>
                                </div>
                              </div>
                            ) : (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "red",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Meta description test </strong>
                                  <small>
                                    Site did not pass meta description test
                                  </small>
                                </div>
                              </div>
                            )}
                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    Meta descriptions are bits of HTML code in
                                    the header of a website. Having them, help
                                    search engines understand what the content
                                    of the page is about. Pages' meta
                                    descriptions are usually shown whenever a
                                    page appears in search engine results.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div">
                              {metaDescription?.length > 1 ? (
                                <small>
                                  This webpage is using a meta description tag{" "}
                                  <i
                                    style={{ color: "#4aac48" }}
                                    className="bi bi-hand-thumbs-up"
                                  ></i>
                                </small>
                              ) : (
                                <small>
                                  This webpage is not using a meta description
                                  tag{" "}
                                  <i
                                    style={{ color: "red" }}
                                    className="bi bi-hand-thumbs-down"
                                  ></i>
                                </small>
                              )}
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              <div>
                                <strong>Description: </strong>
                                <span style={{ fontSize: "14px" }}>
                                  {metaDescription}
                                </span>
                              </div>

                              <div style={{ display: "flex" }}>
                                <strong>Length:&nbsp;</strong>{" "}
                                <p style={{ margin: "0" }}>
                                  {metaDescription?.length} characters
                                </p>
                              </div>
                              <div className="meta-title-recommendations-div-onsite-scraping-results">
                                {metaDescription?.length <= 120 ? (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-danger"
                                    variant={"danger"}
                                  >
                                    Your meta description is too short.
                                    Recommended 120-160 characters.
                                  </Alert>
                                ) : metaDescription?.length >= 160 ? (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-danger"
                                    variant={"danger"}
                                  >
                                    Your meta description is too long.
                                    Recommended is 120-160 characters.
                                  </Alert>
                                ) : (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-success"
                                    variant={"success"}
                                  >
                                    Your meta description is between 120 - 160
                                    characters which is the recommended length.
                                    Good job 💪
                                  </Alert>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  Meta descriptions are bits of HTML code in the
                                  header of a website. Having them, help search
                                  engines understand what the content of the
                                  page is about. Pages' meta descriptions are
                                  usually shown whenever a page appears in
                                  search engine results.
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                            </OverlayTrigger>
                          </div>
                        </div>

                        {/* LINE BREAK: */}
                        <div className="top-card-box-onsite-result-component"></div>

                        {/* GOOGLE RESULTS PREVIEW TEST : ************************************************************* */}
                        <div className="common-seo-issues-inner-div">
                          {/*               <div className="title-div-and-middlemiddle-results-div"> */}
                          <div className="title-div-onsite-result-component">
                            <div className="flag-and-title-div-onsite-result-component">
                              {" "}
                              <i
                                style={{
                                  color: "#808080",
                                  fontSize: "1.5em",
                                  paddingRight: "0.5em",
                                }}
                                className="bi bi-signpost-2-fill"
                              ></i>
                              <div className="meta-title-test-and-overall-recommendation-div">
                                <strong>
                                  Google Search Results Preview Test
                                </strong>
                                {/* <small>Site passed meta description test</small> */}
                              </div>
                            </div>

                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    This is how your page most likely will look
                                    like in a Google search result. Most of the
                                    time Google will display your meta title and
                                    meta description in a result. If these
                                    elements are too long, Google will shorten
                                    them. Titles are recommended to be up to 65
                                    characters in length and descriptions up to
                                    160 characters in length.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div desktop-text">
                              <small>Desktop version: </small>
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              <div className="google-search-preview desktop">
                                <span className="url-format">
                                  {"https://" + urlInput}
                                </span>
                                <span className="title-format line-clamp lines1">
                                  {metaTitle}
                                </span>
                                <span className="description-format line-clamp lines2">
                                  {metaDescription}
                                </span>
                              </div>
                            </div>
                            <div className="webpage-using-a-meta-title-or-not-div">
                              <small>Mobile version: </small>
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              <div className="google-search-preview mobile">
                                <span className="url-format">
                                  {"https://" + urlInput}
                                </span>
                                <span className="title-format line-clamp lines2">
                                  {metaTitle}
                                </span>
                                <span className="description-format line-clamp lines3">
                                  {metaDescription}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  This is how your page most likely will look
                                  like in a Google search result. Most of the
                                  time Google will display your meta title and
                                  meta description in a result. If these
                                  elements are too long, Google will shorten
                                  them. Titles are recommended to be up to 65
                                  characters in length and descriptions up to
                                  160 characters in length.
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                            </OverlayTrigger>
                          </div>
                        </div>

                        {/* LINE BREAK: */}
                        <div className="top-card-box-onsite-result-component"></div>

                        {/* H-TAGS  : ************************************************************* */}
                        <div className="common-seo-issues-inner-div">
                          <div className="title-div-onsite-result-component">
                            {h1Length === 1 ? (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "#4aac48",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Heading tags test </strong>
                                  <small>Site passed headings test</small>
                                </div>
                              </div>
                            ) : (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "red",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Heading tags test </strong>
                                  <small>Site did not pass headings test</small>
                                </div>
                              </div>
                            )}
                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    HTML heading tags are used to format
                                    headings on your page in order of
                                    importance. There are six different HTML
                                    heading tags, from H1 to H6. They go from
                                    most important to least important, with the
                                    size of the text generally decreasing in
                                    size with the importance. The H1 tag is the
                                    one that comes first and shows search
                                    engines what content can be expected on the
                                    rest of the page. H1 tags play an important
                                    role in SEO. All of the important pages on
                                    your site should have H1 tags to draw in the
                                    reader and give a clear indication of the
                                    content on the page. Try to only have one H1
                                    per page, to not confuse search engines.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div">
                              {h1Length === 1 ? (
                                <small>
                                  This webpage has the right amount of H1 tags{" "}
                                  <i
                                    style={{ color: "#4aac48" }}
                                    className="bi bi-hand-thumbs-up"
                                  ></i>
                                </small>
                              ) : h1Length < 1 ? (
                                <small>
                                  This webpage does not have a H1 tag{" "}
                                  <i
                                    style={{ color: "red" }}
                                    className="bi bi-hand-thumbs-down"
                                  ></i>
                                </small>
                              ) : (
                                <small>
                                  This webpage has too many H1 tags{" "}
                                  <i
                                    style={{ color: "red" }}
                                    className="bi bi-hand-thumbs-down"
                                  ></i>
                                </small>
                              )}
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              <div>
                                <strong>H1 tags: </strong>
                                <span style={{ fontSize: "14px" }}>
                                  This webpage has <strong> {h1Length}</strong>{" "}
                                  H1 tags
                                </span>
                              </div>

                              <div className="meta-title-recommendations-div-onsite-scraping-results">
                                {h1Length < 1 ? (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-danger"
                                    variant={"danger"}
                                  >
                                    You do not have a H1 tag. It is recommended
                                    to have 1 H1 tag on each page.
                                  </Alert>
                                ) : h1Length > 1 ? (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-danger"
                                    variant={"danger"}
                                  >
                                    You have too many H1 tags. It is best to
                                    just have 1 H1 tag on each page.
                                  </Alert>
                                ) : (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-success"
                                    variant={"success"}
                                  >
                                    You have 1 H1 tag which is the recommeded
                                    amount. Good job 💪
                                  </Alert>
                                )}
                                <div>
                                  <strong>H2 tags: </strong>
                                  <span style={{ fontSize: "14px" }}>
                                    This webpage has{" "}
                                    <strong> {h2Length}</strong> H2 tags
                                  </span>
                                </div>
                                <div>
                                  <strong>H3 tags: </strong>
                                  <span style={{ fontSize: "14px" }}>
                                    This webpage has{" "}
                                    <strong> {h3Length}</strong> H3 tags
                                  </span>
                                </div>
                                <div>
                                  <strong>H4 tags: </strong>
                                  <span style={{ fontSize: "14px" }}>
                                    This webpage has{" "}
                                    <strong> {h4Length}</strong> H4 tags
                                  </span>
                                </div>
                                <div>
                                  <strong>H5 tags: </strong>
                                  <span style={{ fontSize: "14px" }}>
                                    This webpage has{" "}
                                    <strong> {h5Length}</strong> H5 tags
                                  </span>
                                </div>
                                <div>
                                  <strong>H6 tags: </strong>
                                  <span style={{ fontSize: "14px" }}>
                                    This webpage has{" "}
                                    <strong> {h6Length}</strong> H6 tags
                                  </span>
                                </div>

                                {showFullListOfHeadings === false ? (
                                  <div
                                    style={{ maxWidth: "450px" }}
                                    className="mt-4"
                                    onClick={showHeadingsFunction}
                                  >
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Show the whole list of headings in
                                      chronological order
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    className="mt-4"
                                    onClick={hideHeadingsFunction}
                                  >
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Hide the whole list of headings
                                    </span>
                                  </div>
                                )}
                                {showFullListOfHeadings === true ? (
                                  <div
                                    className="pt-4"
                                    style={{ maxWidth: "450px" }}
                                  >
                                    <strong>
                                      These are all your H-tags in chronological
                                      order:{" "}
                                    </strong>
                                    <span style={{ fontSize: "14px" }}>
                                      {arrayWithAllHInformation?.map(
                                        (e, index) => {
                                          return <p key={index}>{e}</p>;
                                        }
                                      )}
                                    </span>
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* </div> */}
                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  HTML heading tags are used to format headings
                                  on your page in order of importance. There are
                                  six different HTML heading tags, from H1 to
                                  H6. They go from most important to least
                                  important, with the size of the text generally
                                  decreasing in size with the importance. The H1
                                  tag is the one that comes first and shows
                                  search engines what content can be expected on
                                  the rest of the page. H1 tags play an
                                  important role in SEO. All of the important
                                  pages on your site should have H1 tags to draw
                                  in the reader and give a clear indication of
                                  the content on the page. Try to only have one
                                  H1 per page, to not confuse search engines.
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                            </OverlayTrigger>
                          </div>
                        </div>

                        {/* LINE BREAK: */}
                        <div className="top-card-box-onsite-result-component"></div>

                        {/* IMAGE ALT TAGS  : ************************************************************* */}
                        <div className="common-seo-issues-inner-div">
                          <div className="title-div-onsite-result-component">
                            {numberOfEmptyAltTexts < 1 ? (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "#4aac48",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Image Alt text test </strong>
                                  <small>Site passed image Alt text test</small>
                                </div>
                              </div>
                            ) : numberOfEmptyAltTexts < 5 ? (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "#a1a102",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Image Alt text test </strong>
                                  <small>
                                    Site has some small issues regarding image
                                    Alt texts
                                  </small>
                                </div>
                              </div>
                            ) : (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "red",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Image Alt text test </strong>
                                  <small>
                                    Site did not pass the image Alt texts test
                                  </small>
                                </div>
                              </div>
                            )}
                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    Alt texts are text alternatives to images
                                    when a browser can’t properly render them or
                                    to help visually impaired people know what
                                    the image shows. Similar to the title, the
                                    alt attribute is used to describe the
                                    contents of an image file. Adding
                                    appropriate alt texts to the images on your
                                    website can help your website achieve better
                                    rankings in the search engines by
                                    associating keywords with images. It
                                    provides Google with useful information
                                    about the subject matter of the image.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div">
                              {numberOfEmptyAltTexts === 0 ? (
                                <small>
                                  This webpage has 0 missing Alt texts{" "}
                                  <i
                                    style={{ color: "#4aac48" }}
                                    className="bi bi-hand-thumbs-up"
                                  ></i>
                                </small>
                              ) : (
                                <small>
                                  This webpage has missing Alt texts{" "}
                                  <i
                                    style={{ color: "red" }}
                                    className="bi bi-hand-thumbs-down"
                                  ></i>
                                </small>
                              )}
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              <div>
                                <strong>Missing Alt texts: </strong>
                                <span style={{ fontSize: "14px" }}>
                                  <strong> {numberOfEmptyAltTexts}</strong>
                                </span>
                              </div>

                              <div className="meta-title-recommendations-div-onsite-scraping-results">
                                {numberOfEmptyAltTexts >= 1 ? (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-danger"
                                    variant={"danger"}
                                  >
                                    The webpage has {numberOfEmptyAltTexts}{" "}
                                    missing Alt texts. It is best not to have
                                    any missing Alt texts.
                                  </Alert>
                                ) : (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-success"
                                    variant={"success"}
                                  >
                                    The webpage has 0 missing Alt texts. Good
                                    job 💪
                                  </Alert>
                                )}

                                {showFullListOfImageAltTexts === false ? (
                                  <div
                                    style={{ maxWidth: "450px" }}
                                    className="mt-4"
                                    onClick={showImageAltTextsFunction}
                                  >
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Show the whole list of image Alt texts in
                                      chronological order
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    className="mt-4"
                                    onClick={hideImageAltTextsFunction}
                                  >
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Hide the whole list of image Alt texts
                                    </span>
                                  </div>
                                )}
                                {showFullListOfImageAltTexts === true ? (
                                  <div
                                    className="pt-4"
                                    style={{ maxWidth: "450px" }}
                                  >
                                    <strong>
                                      These are all your image Alt texts in
                                      chronological order:{" "}
                                    </strong>
                                    <span style={{ fontSize: "14px" }}>
                                      {imageSrcAndAltTexts?.map((e, index) => {
                                        return (
                                          <div className="mt-3" key={index}>
                                            <strong>Image {index + 1}:</strong>
                                            <br /> Image source:{" "}
                                            <a
                                              target="_blank"
                                              href={`${e.imageSrc}`}
                                            >
                                              {e.imageSrc.slice(0, 34) + "..."}
                                            </a>
                                            <p>
                                              Image Alt text:{" "}
                                              {e.altText.length > 1 ? (
                                                <span> {e.altText} </span>
                                              ) : (
                                                <span style={{ color: "red" }}>
                                                  Alt text missing
                                                </span>
                                              )}{" "}
                                              {/* {e.altText} */}
                                            </p>
                                          </div>
                                        );
                                      })}
                                    </span>
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* </div> */}
                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  Alt texts are text alternatives to images when
                                  a browser can’t properly render them or to
                                  help visually impaired people know what the
                                  image shows. Similar to the title, the alt
                                  attribute is used to describe the contents of
                                  an image file. Adding appropriate alt texts to
                                  the images on your website can help your
                                  website achieve better rankings in the search
                                  engines by associating keywords with images.
                                  It provides Google with useful information
                                  about the subject matter of the image.
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                            </OverlayTrigger>
                          </div>
                        </div>

                        {/* LINE BREAK: */}
                        <div className="top-card-box-onsite-result-component"></div>

                        {/* ROBOTS.TXT FILE COMING BELOW HERE  : ************************************************************* */}
                        <div className="common-seo-issues-inner-div">
                          <div className="title-div-onsite-result-component">
                            {robotsTXTExists === true ? (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "#4aac48",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Robots.txt test </strong>
                                  <small>Site passed Robots.txt test</small>
                                </div>
                              </div>
                            ) : (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "red",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Robots.txt test </strong>
                                  <small>
                                    Site did not pass Robots.txt test
                                  </small>
                                </div>
                              </div>
                            )}
                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    Robots.txt is a text file webmasters create
                                    to instruct search engine robots how to
                                    crawl their website. In practice, robots.txt
                                    files indicate your "crawl instructions" to
                                    search engine robots. These crawl
                                    instructions are specified by “disallowing”
                                    or “allowing” the behaviour of certain (or
                                    all) crawlers.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div">
                              {robotsTXTExists === true ? (
                                <small>
                                  This webpage has a Robots.txt file{" "}
                                  <i
                                    style={{ color: "#4aac48" }}
                                    className="bi bi-hand-thumbs-up"
                                  ></i>
                                </small>
                              ) : (
                                <small>
                                  This webpage is missing a Robots.txt file{" "}
                                  <i
                                    style={{ color: "red" }}
                                    className="bi bi-hand-thumbs-down"
                                  ></i>
                                </small>
                              )}
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              {robotsTXTExists === true ? (
                                <div>
                                  <strong>Robots.txt file: </strong>
                                  <span style={{ fontSize: "14px" }}>
                                    <strong>
                                      <a
                                        target="_blank"
                                        href={`${
                                          "https://" + urlInput + "/robots.txt"
                                        }`}
                                      >
                                        {urlInput + "/robots.txt"}
                                      </a>{" "}
                                    </strong>
                                  </span>
                                </div>
                              ) : (
                                <div>
                                  <strong>No Robots.txt file found </strong>
                                  <span style={{ fontSize: "14px" }}></span>
                                </div>
                              )}

                              <div className="meta-title-recommendations-div-onsite-scraping-results">
                                {robotsTXTExists === false ? (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-danger"
                                    variant={"danger"}
                                  >
                                    The webpage is missing a Robots.txt file. It
                                    is alwasy best to have one. You can read
                                    about what a Robots.txt file is{" "}
                                    {
                                      <a href="https://developers.google.com/search/docs/advanced/robots/robots_txt">
                                        here.
                                      </a>
                                    }
                                    .
                                  </Alert>
                                ) : (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-success"
                                    variant={"success"}
                                  >
                                    The webpage has a Robots.txt file. Good job
                                    💪
                                  </Alert>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* </div> */}
                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  Robots.txt is a text file webmasters create to
                                  instruct search engine robots how to crawl
                                  their website. In practice, robots.txt files
                                  indicate your "crawl instructions" to search
                                  engine robots. These crawl instructions are
                                  specified by “disallowing” or “allowing” the
                                  behaviour of certain (or all) crawlers.
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                            </OverlayTrigger>
                          </div>
                        </div>

                        {/* LINE BREAK: */}
                        <div className="top-card-box-onsite-result-component"></div>

                        {/* FAVICON TEST COMING BELOW HERE  : ************************************************************* */}
                        <div className="common-seo-issues-inner-div">
                          <div className="title-div-onsite-result-component">
                            {faviconFromWebsite?.length > 1 ? (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "#4aac48",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Favicon test </strong>
                                  <small>Site passed favicon test</small>
                                </div>
                              </div>
                            ) : (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "red",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>Favicon test </strong>
                                  <small>Site did not pass favicon test</small>
                                </div>
                              </div>
                            )}
                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    A favicon is a small icon associated with a
                                    website. Favicons are used in browser tabs,
                                    browser history, toolbar apps, bookmarks
                                    dropdown, search bar, and search bar
                                    recommendations. Having a favicon helps with
                                    branding your site and makes it easy for
                                    your users to remember and to navigate to
                                    your site.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div">
                              {faviconFromWebsite?.length > 1 ? (
                                <small>
                                  This webpage has a favicon{" "}
                                  <i
                                    style={{ color: "#4aac48" }}
                                    className="bi bi-hand-thumbs-up"
                                  ></i>
                                </small>
                              ) : (
                                <small>
                                  This webpage is missing a favicon{" "}
                                  <i
                                    style={{ color: "red" }}
                                    className="bi bi-hand-thumbs-down"
                                  ></i>
                                </small>
                              )}
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              {faviconFromWebsite?.length > 1 ? (
                                <div>
                                  <strong>Favicon: </strong>
                                  <span style={{ fontSize: "14px" }}>
                                    <strong>
                                      <a
                                        target="_blank"
                                        href={`${faviconFromWebsite}`}
                                      >
                                        {faviconFromWebsite}
                                      </a>{" "}
                                    </strong>
                                  </span>
                                </div>
                              ) : (
                                <div>
                                  <strong>No favicon found </strong>
                                  <span style={{ fontSize: "14px" }}></span>
                                </div>
                              )}

                              <div className="meta-title-recommendations-div-onsite-scraping-results">
                                {faviconFromWebsite === undefined ? (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-danger"
                                    variant={"danger"}
                                  >
                                    The webpage is missing a favicon. It is
                                    alwasy best to have a favicon. You should
                                    add one.
                                  </Alert>
                                ) : (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-success"
                                    variant={"success"}
                                  >
                                    The webpage has a favicon. Good job 💪
                                  </Alert>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* </div> */}
                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  A favicon is a small icon associated with a
                                  website. Favicons are used in browser tabs,
                                  browser history, toolbar apps, bookmarks
                                  dropdown, search bar, and search bar
                                  recommendations. Having a favicon helps with
                                  branding your site and makes it easy for your
                                  users to remember and to navigate to your
                                  site.
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                            </OverlayTrigger>
                          </div>
                        </div>

                        {/* LINE BREAK: */}
                        <div className="top-card-box-onsite-result-component"></div>

                        {/* MOST COMMON USED KEYWORDS BELOW HERE : ************************************************************* */}
                        <div className="common-seo-issues-inner-div">
                          <div className="title-div-onsite-result-component">
                            <div className="flag-and-title-div-onsite-result-component">
                              {" "}
                              <i
                                style={{
                                  color: "#808080",
                                  fontSize: "1.5em",
                                  paddingRight: "0.5em",
                                }}
                                className="bi bi-sort-down"
                              ></i>
                              <div className="meta-title-test-and-overall-recommendation-div">
                                <strong>Most common used keywords </strong>
                                {/* <small>Site passed favicon test</small> */}
                              </div>
                            </div>

                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    This is showing the most common used
                                    keywords on this page and the number of
                                    times it is used. Crawlers migth associate
                                    these keywords with your website.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div">
                              <small>
                                These are the keywords that appear on the site
                                the most. This can be useful, as search engine
                                algorithms use these to determine what the topic
                                of your page is about.{" "}
                                {/* <i
                          style={{ color: "#4aac48" }}
                          className="bi bi-hand-thumbs-up"
                        ></i> */}
                              </small>
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              <div>
                                <strong>Top 10 most used keywords: </strong>
                                <div className="mb-2"></div>
                                {/* <span style={{ fontSize: "14px" }}>
                                 */}
                                {mostCommonKeywords
                                  ?.slice(0, 10)
                                  .map((e, index) => (
                                    <div key={index}>
                                      <Badge pill variant="light">
                                        {" "}
                                        <Badge variant="secondary">
                                          {e[1]}
                                        </Badge>{" "}
                                        {e[0]}
                                      </Badge>
                                    </div>
                                  ))}
                              </div>

                              {showFullListOfKeywords === false ? (
                                <div>
                                  <div
                                    style={{ maxWidth: "450px" }}
                                    className="mt-4"
                                    onClick={showFullListOfKeywordsFunction}
                                  >
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Show the whole list of keywords
                                    </span>
                                  </div>
                                  {/* //HIDING THE "TRACK YOUR KEYWORDS NOW" PROMO ON THIS REPORT PAGE  */}
                                  {/*  <div className="promo-content mt-4">
                                <h6>Start tracking your keywords</h6>
                                <p>
                                  Would you like to know what your ranking on
                                  Google is for these keywords on a daily basis?
                                </p>
                                <p>
                                  Just sign up for our free trial and start
                                  using our keyword tracker.
                                </p>
                                <div class="sign-up-now-button-div">
                                  <Button
                                    type="button"
                                    variant="success"
                                    class="track-your-keywords-now-button"
                                    size="lg"
                                    onClick={takeMetoSignUpFunction}
                                  >
                                    <span>
                                      START TRACKING{" "}
                                      <i class="bi bi-lightning-charge"></i>
                                    </span>
                                  </Button>
                                </div>
                              </div> */}
                                </div>
                              ) : (
                                <div
                                  className="mt-4"
                                  onClick={hideFullListOfKeywordsFunction}
                                >
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Hide the whole list of keywords
                                  </span>
                                </div>
                              )}
                              {showFullListOfKeywords === true ? (
                                <div
                                  className="pt-4"
                                  style={{ maxWidth: "450px" }}
                                >
                                  <strong>These are all the keywords: </strong>
                                  <span style={{ fontSize: "14px" }}>
                                    {mostCommonKeywords?.map((e, index) => (
                                      <div key={index} className={e.index}>
                                        <Badge pill variant="light">
                                          {" "}
                                          <Badge variant="secondary">
                                            {e[1]}
                                          </Badge>{" "}
                                          {e[0]}
                                        </Badge>
                                      </div>
                                    ))}

                                    {/* {imageSrcAndAltTexts?.map((e, index) => {
                            return (
                              <div className="mt-3" key={index}>
                                <strong>Image {index + 1}:</strong>
                                <br /> Image source:{" "}
                                <a target="_blank" href={`${e.imageSrc}`}>
                                  {e.imageSrc.slice(0, 34) + "..."}
                                </a>
                                <p>
                                  Image Alt text:{" "}
                                  {e.altText.length > 1 ? (
                                    <span> {e.altText} </span>
                                  ) : (
                                    <span style={{ color: "red" }}>
                                      Alt text missing
                                    </span>
                                  )}{" "}

                                </p>
                              </div>
                            );
                          })} */}
                                  </span>
                                </div>
                              ) : (
                                <></>
                              )}

                              <div className="meta-title-recommendations-div-onsite-scraping-results"></div>
                            </div>
                          </div>
                          {/* </div> */}
                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  This is showing the most common used keywords
                                  on this page and the number of times it is
                                  used. Crawlers migth associate these keywords
                                  with your website.
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                            </OverlayTrigger>
                          </div>
                        </div>

                        {/* LINE BREAK: */}
                        <div className="top-card-box-onsite-result-component"></div>

                        {/* INTERNAL LINKS SECTION : ************************************************************* */}
                        <div className="common-seo-issues-inner-div">
                          <div className="title-div-onsite-result-component">
                            <div className="flag-and-title-div-onsite-result-component">
                              {" "}
                              <i
                                style={{
                                  color: "#808080",
                                  fontSize: "1.5em",
                                  paddingRight: "0.5em",
                                }}
                                className="bi bi-link-45deg"
                              ></i>
                              <div className="meta-title-test-and-overall-recommendation-div">
                                <strong>Internal links </strong>
                                {/* <small>Site passed favicon test</small> */}
                              </div>
                            </div>

                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    When a link is linking from one page to
                                    another page within the same web site it is
                                    called an "internal link". Google analyses
                                    internal links to understand the most
                                    important pages on a website.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div">
                              <small>
                                These are the most linked to internal pages on
                                this web page. Search engines analyses internal
                                links to understand the most important pages on
                                a website.
                                {/* <i
            style={{ color: "#4aac48" }}
            className="bi bi-hand-thumbs-up"
          ></i> */}
                              </small>
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              <div>
                                <strong>Top 5 internal links: </strong>
                                <div className="mb-2"></div>

                                {/* <span style={{ fontSize: "14px" }}>
                                 */}
                                {internalLinks?.slice(0, 5).map((e, index) => (
                                  <div
                                    key={index}
                                    className="internal-and-external-links-outer-div"
                                  >
                                    <div>
                                      <Badge
                                        pill
                                        variant="secondary"
                                        className="badge-for-external-and-internal-links"
                                      >
                                        {" "}
                                        {e[1]}
                                        {/*                             <Badge variant="secondary"> </Badge> */}
                                        {/* {e[0].length >= 40
                              ? " " + e[0].slice(0, 40) + "..."
                              : " " + e[0]} */}{" "}
                                      </Badge>
                                    </div>
                                    <div className="ml-2">
                                      <small>
                                        <a target="_blank" href={e[0]}>
                                          {e[0]}
                                        </a>{" "}
                                      </small>
                                    </div>
                                  </div>
                                ))}
                              </div>

                              {showFullListOfInternalLinks === false ? (
                                <div
                                  style={{ maxWidth: "450px" }}
                                  className="mt-4"
                                  onClick={showFullListOfInternalLinksFunction}
                                >
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Show the whole list of internal links
                                  </span>
                                </div>
                              ) : (
                                <div
                                  className="mt-4"
                                  onClick={hideFullListOfInternalLinksFunction}
                                >
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Hide the whole list of internal links
                                  </span>
                                </div>
                              )}
                              {showFullListOfInternalLinks === true ? (
                                <div
                                  className="pt-4"
                                  style={{ maxWidth: "450px" }}
                                >
                                  <strong>
                                    These are all the internal links:{" "}
                                  </strong>
                                  <div className="mb-2"></div>
                                  <span style={{ fontSize: "14px" }}>
                                    {internalLinks?.map((e, index) => (
                                      <div
                                        key={index}
                                        className="internal-and-external-links-outer-div"
                                      >
                                        <div className={e.index}>
                                          <Badge
                                            pill
                                            variant="secondary"
                                            className="badge-for-external-and-internal-links"
                                          >
                                            {" "}
                                            {e[1]}
                                            {/*                             <Badge variant="secondary"> </Badge> */}
                                            {/* {e[0].length >= 40
                              ? " " + e[0].slice(0, 40) + "..."
                              : " " + e[0]} */}{" "}
                                          </Badge>
                                        </div>
                                        <div className="ml-2">
                                          <small>
                                            <a target="_blank" href={e[0]}>
                                              {e[0]}
                                            </a>{" "}
                                          </small>
                                        </div>
                                      </div>
                                    ))}
                                  </span>
                                </div>
                              ) : (
                                <></>
                              )}

                              <div className="meta-title-recommendations-div-onsite-scraping-results"></div>
                            </div>
                          </div>
                          {/* </div> */}
                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  When a link is linking from one page to
                                  another page within the same web site it is
                                  called an "internal link". Google analyses
                                  internal links to understand the most
                                  important pages on a website.
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                            </OverlayTrigger>
                          </div>
                        </div>

                        {/* LINE BREAK: */}
                        <div className="top-card-box-onsite-result-component"></div>

                        {/* EXTERNAL LINKS SECTION : ************************************************************* */}
                        <div className="common-seo-issues-inner-div">
                          <div className="title-div-onsite-result-component">
                            <div className="flag-and-title-div-onsite-result-component">
                              {" "}
                              <i
                                style={{
                                  color: "#808080",
                                  fontSize: "1.5em",
                                  paddingRight: "0.5em",
                                }}
                                className="bi bi-box-arrow-up-right"
                              ></i>
                              <div className="meta-title-test-and-overall-recommendation-div">
                                <strong>Outgoing links </strong>
                                {/* <small>Site passed favicon test</small> */}
                              </div>
                            </div>

                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    When a link is pointing to a domain that is
                                    different from the domain from where the
                                    link exists on, it is called an "external
                                    link". External links have impact on search
                                    engine rankings as they are seen as a vote
                                    of confidence.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div">
                              <small>
                                These are the pages that are being linked to the
                                most.
                                {/* <i
style={{ color: "#4aac48" }}
className="bi bi-hand-thumbs-up"
></i> */}
                              </small>
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              <div>
                                <strong>Top 5 outgoing links: </strong>
                                <div className="mb-2"></div>

                                {/* <span style={{ fontSize: "14px" }}>
                                 */}
                                {externalLinks ? (
                                  externalLinks?.slice(0, 5).map((e, index) => (
                                    <div
                                      key={index}
                                      className="internal-and-external-links-outer-div"
                                    >
                                      <div>
                                        <Badge
                                          pill
                                          variant="secondary"
                                          className="badge-for-external-and-internal-links"
                                        >
                                          {" "}
                                          {e[1]}
                                        </Badge>
                                      </div>
                                      <div className="ml-2">
                                        <small>
                                          <a target="_blank" href={e[0]}>
                                            {e[0]}
                                          </a>{" "}
                                        </small>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div></div>
                                )}
                              </div>

                              {showFullListOfExternalLinks === false ? (
                                <div
                                  style={{ maxWidth: "450px" }}
                                  className="mt-4"
                                  onClick={showFullListOfExternalLinksFunction}
                                >
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Show the whole list of outgoing links
                                  </span>
                                </div>
                              ) : (
                                <div
                                  className="mt-4"
                                  onClick={hideFullListOfExternalLinksFunction}
                                >
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Hide the whole list of outgoing links
                                  </span>
                                </div>
                              )}
                              {showFullListOfExternalLinks === true ? (
                                <div
                                  className="pt-4"
                                  style={{ maxWidth: "450px" }}
                                >
                                  <strong>
                                    These are all the outgoing links:{" "}
                                  </strong>
                                  <div className="mb-2"></div>
                                  <span style={{ fontSize: "14px" }}>
                                    {externalLinks?.map((e, index) => (
                                      <div
                                        key={index}
                                        className="internal-and-external-links-outer-div"
                                      >
                                        <div className={e.index}>
                                          <Badge
                                            pill
                                            variant="secondary"
                                            className="badge-for-external-and-internal-links"
                                          >
                                            {" "}
                                            {e[1]}
                                          </Badge>
                                        </div>
                                        <div className="ml-2">
                                          <small>
                                            <a target="_blank" href={e[0]}>
                                              {e[0]}
                                            </a>{" "}
                                          </small>
                                        </div>
                                      </div>
                                    ))}
                                  </span>
                                </div>
                              ) : (
                                <></>
                              )}

                              <div className="meta-title-recommendations-div-onsite-scraping-results"></div>
                            </div>
                          </div>
                          {/* </div> */}
                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  When a link is pointing to a domain that is
                                  different from the domain from where the link
                                  exists on, it is called an "external link".
                                  External links have impact on search engine
                                  rankings as they are seen as a vote of
                                  confidence.
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                            </OverlayTrigger>
                          </div>
                        </div>

                        {/* LINE BREAK: */}
                        <div className="top-card-box-onsite-result-component"></div>

                        {/* OUTGOING NOFOLLOW LINKS SECTION : ************************************************************* */}
                        <div className="common-seo-issues-inner-div">
                          <div className="title-div-onsite-result-component">
                            <div className="flag-and-title-div-onsite-result-component">
                              {" "}
                              <i
                                style={{
                                  color: "#808080",
                                  fontSize: "1.5em",
                                  paddingRight: "0.5em",
                                }}
                                className="bi-box-arrow-in-up-right"
                              ></i>
                              <div className="meta-title-test-and-overall-recommendation-div">
                                <strong>
                                  Outgoing{" "}
                                  <span style={{ textDecoration: "underline" }}>
                                    no-follow
                                  </span>{" "}
                                  links{" "}
                                </strong>
                                {/* <small>Site passed favicon test</small> */}
                              </div>
                            </div>

                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    A "no-follow" link is a hyperlink with a
                                    rel=“nofollow” tag. No-follow links are used
                                    to link to a page, without giving any
                                    ranking credit or link-juice to that
                                    specific site. You can read more about
                                    no-follow links{" "}
                                    <a href="https://developers.google.com/search/blog/2019/09/evolving-nofollow-new-ways-to-identify">
                                      here on Google.
                                    </a>
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div">
                              {outGoingNoFollowLinks?.length > 0 ? (
                                <small>
                                  This page has outgoing no-follow links.
                                  {/* <i
style={{ color: "#4aac48" }}
className="bi bi-hand-thumbs-up"
></i> */}
                                </small>
                              ) : (
                                <small>
                                  This page does not have any outgoing no-follow
                                  links.
                                  {/* <i
style={{ color: "#4aac48" }}
className="bi bi-hand-thumbs-up"
></i> */}
                                </small>
                              )}
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              <div>
                                <strong>
                                  Number of outgoing no-follow links:{" "}
                                  {outGoingNoFollowLinks?.length}{" "}
                                </strong>
                                <div className="mb-2"></div>
                              </div>

                              {showFullListOfOutgoingNoFollowLinks === false ? (
                                <div
                                  style={{ maxWidth: "450px" }}
                                  className="mt-4"
                                  onClick={
                                    showFullListOfOutgoingNoFollowLinksFunction
                                  }
                                >
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Show the whole list of outgoing no-follow
                                    links
                                  </span>
                                </div>
                              ) : (
                                <div
                                  className="mt-4"
                                  onClick={
                                    hideFullListOfOutgoingNoFollowLinksFunction
                                  }
                                >
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Hide the whole list of outgoing no-follw
                                    links
                                  </span>
                                </div>
                              )}
                              {showFullListOfOutgoingNoFollowLinks === true ? (
                                <div
                                  className="pt-4"
                                  style={{ maxWidth: "450px" }}
                                >
                                  <strong>
                                    These are all the outgoing no-follow links:{" "}
                                  </strong>
                                  <div className="mb-2"></div>
                                  <span style={{ fontSize: "14px" }}>
                                    {outGoingNoFollowLinks?.map((e, index) => (
                                      <div
                                        key={index}
                                        className="internal-and-external-links-outer-div"
                                      >
                                        <div className={e.index}>
                                          <Badge
                                            pill
                                            variant="secondary"
                                            className="badge-for-external-and-internal-links"
                                          >
                                            {" "}
                                            {index + 1}
                                          </Badge>
                                        </div>
                                        <div className="ml-2">
                                          <small>
                                            <a target="_blank" href={e[0]}>
                                              {e[0]}
                                            </a>{" "}
                                          </small>
                                        </div>
                                      </div>
                                    ))}
                                  </span>
                                </div>
                              ) : (
                                <></>
                              )}

                              <div className="meta-title-recommendations-div-onsite-scraping-results"></div>
                            </div>
                          </div>
                          {/* </div> */}
                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  A "no-follow" link is a hyperlink with a
                                  rel=“nofollow” tag. No-follow links are used
                                  to link to a page, without giving any ranking
                                  credit or link-juice to that specific site.
                                  You can read more about no-follow links{" "}
                                  <a href="https://developers.google.com/search/blog/2019/09/evolving-nofollow-new-ways-to-identify">
                                    here on Google.
                                  </a>
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                            </OverlayTrigger>
                          </div>
                        </div>
                      </div>

                      {/* SERVER AND SECURITY SECTION ***************************************************/}
                      <div
                        className="d-flex common-seo-issues-outer-div mt-3"
                        style={{ background: "white" }}
                      >
                        <div className="top-card-box-onsite-result-component">
                          <h4>Server and security</h4>
                        </div>
                        {/* HTTPS CHECKER SECTION  *****************************************************/}
                        <div className="common-seo-issues-inner-div">
                          {/*               <div className="title-div-and-middlemiddle-results-div"> */}

                          <div className="title-div-onsite-result-component">
                            {isHttpsSupported === true ? (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "#4aac48",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>HTTPS test </strong>
                                  <small>Site passed HTTPS test</small>
                                </div>
                              </div>
                            ) : (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "red",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>HTTPS test </strong>
                                  <small>
                                    Site did not pass the HTTPS test
                                  </small>
                                </div>
                              </div>
                            )}
                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    Hypertext Transfer Protocol Secure (HTTPS)
                                    is an extension of the Hypertext Transfer
                                    Protocol (HTTP). It is used in order to make
                                    communication over a computer network
                                    secure. HTTPS uses TLS (SSL) to encrypt
                                    requests and responses. Therefore, HTTPS is
                                    much more secure than HTTP.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div">
                              {isHttpsSupported === true ? (
                                <small>
                                  This webpage is using HTTPS{" "}
                                  <i
                                    style={{ color: "#4aac48" }}
                                    className="bi bi-hand-thumbs-up"
                                  ></i>
                                </small>
                              ) : (
                                <small>
                                  This webpage is not using HTTPS{" "}
                                  <i
                                    style={{ color: "red" }}
                                    className="bi bi-hand-thumbs-down"
                                  ></i>
                                </small>
                              )}
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              <div className="meta-title-recommendations-div-onsite-scraping-results">
                                {isHttpsSupported === false ? (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-danger"
                                    variant={"danger"}
                                  >
                                    This website is not using HTTPS. This means
                                    that users are not protected against
                                    eavesdroppers and man-in-the-middle (MitM)
                                    attacks.
                                  </Alert>
                                ) : (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-success"
                                    variant={"success"}
                                  >
                                    This website is successfully using HTTPS,
                                    which protects users against eavesdroppers
                                    and man-in-the-middle (MitM) attacks. Good
                                    job 💪
                                  </Alert>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* </div> */}
                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  Hypertext Transfer Protocol Secure (HTTPS) is
                                  an extension of the Hypertext Transfer
                                  Protocol (HTTP). It is used in order to make
                                  communication over a computer network secure.
                                  HTTPS uses TLS (SSL) to encrypt requests and
                                  responses. Therefore, HTTPS is much more
                                  secure than HTTP.
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                            </OverlayTrigger>
                          </div>
                        </div>

                        {/* LINE BREAK: */}
                        <div className="top-card-box-onsite-result-component"></div>

                        {/* SSL INFO SECTION *************************************************************** */}
                        <div className="common-seo-issues-inner-div">
                          {/*               <div className="title-div-and-middlemiddle-results-div"> */}

                          <div className="title-div-onsite-result-component">
                            {sslInfo?.valid === true ? (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "#4aac48",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>SSL test </strong>
                                  <small>
                                    Site passed SSL certificate test
                                  </small>
                                </div>
                              </div>
                            ) : (
                              <div className="flag-and-title-div-onsite-result-component">
                                {" "}
                                <i
                                  style={{
                                    color: "red",
                                    fontSize: "1.5em",
                                    paddingRight: "0.5em",
                                  }}
                                  className="bi bi-flag"
                                ></i>
                                <div className="meta-title-test-and-overall-recommendation-div">
                                  <strong>SSL test </strong>
                                  <small>
                                    Site did not pass the SSL certificate test
                                  </small>
                                </div>
                              </div>
                            )}
                            <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                              <OverlayTrigger
                                key="left"
                                placement="left"
                                overlay={
                                  <Tooltip id={`tooltip-${"left"}`}>
                                    Secure Sockets Layer (SSL) is the standard
                                    technology for keeping an internet
                                    connection secure. SSL is using an
                                    encryption algorithms when sending data,
                                    which prevents hackers from reading it.
                                  </Tooltip>
                                }
                              >
                                <i className="bi bi-info-circle"></i>
                                {/*                     <Button variant="secondary">Tooltip on </Button> */}
                              </OverlayTrigger>
                            </div>
                          </div>
                          <div className="meta-title-report-to-the-right">
                            <div className="webpage-using-a-meta-title-or-not-div">
                              {sslInfo?.valid === true ? (
                                <small>
                                  This webpage is using SSL certificate{" "}
                                  <i
                                    style={{ color: "#4aac48" }}
                                    className="bi bi-hand-thumbs-up"
                                  ></i>
                                </small>
                              ) : (
                                <small>
                                  This webpage might not have a valid SSL
                                  certificate{" "}
                                  <i
                                    style={{ color: "red" }}
                                    className="bi bi-hand-thumbs-down"
                                  ></i>
                                </small>
                              )}
                            </div>
                            <div className="meta-title-and-meta-title-length-div">
                              {sslInfo?.valid === true ? (
                                <div>
                                  <div style={{ display: "flex" }}>
                                    <strong>
                                      SSL certificate valid from:&nbsp;
                                    </strong>{" "}
                                    <p style={{ margin: "0" }}>
                                      {SSLValidFrom}
                                    </p>
                                  </div>
                                  <div style={{ display: "flex" }}>
                                    <strong>
                                      SSL certificate valid to:&nbsp;
                                    </strong>{" "}
                                    <p style={{ margin: "0" }}>{SSLValidTo}</p>
                                  </div>
                                  <div>
                                    <strong>Days remaining: </strong>
                                    <span style={{ fontSize: "14px" }}>
                                      {sslInfo?.daysRemaining}
                                    </span>
                                  </div>
                                  <div>
                                    <strong>
                                      SSL certificate is valid for these
                                      domains:{" "}
                                    </strong>
                                    <span style={{ fontSize: "14px" }}>
                                      {sslInfo?.validFor.map((e) => e + ", ")}
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <div></div>
                              )}
                              <div className="meta-title-recommendations-div-onsite-scraping-results">
                                {sslInfo?.valid === true ? (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-success"
                                    variant={"success"}
                                  >
                                    This website has a valid SSL certificate,
                                    which helps with keeping sensitive
                                    information like usernames, passwords,
                                    credit cards, etc. secure by encrypting the
                                    data. Good job 💪
                                  </Alert>
                                ) : (
                                  <Alert
                                    style={{ margin: "0" }}
                                    className="alert-messages-meta-checker-danger"
                                    variant={"danger"}
                                  >
                                    This website might not have a valid SSL
                                    certificate.
                                    <br></br>
                                    <br></br>
                                    To be 100% sure - be sure you are using the
                                    root domain when testing for{" "}
                                    <b>{urlInput}</b> without any "/" in the
                                    end.<br></br>
                                    <br></br>Browsers might block the website
                                    and warn users that the website cannot be
                                    trusted if you do not have a valid SSL
                                    certificate.<br></br>
                                    <br></br> This should be fixed immediately.
                                  </Alert>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* </div> */}
                          <div className="overlay-trigger-div-only-shown-on-large-screens">
                            <OverlayTrigger
                              key="left"
                              placement="left"
                              overlay={
                                <Tooltip id={`tooltip-${"left"}`}>
                                  Secure Sockets Layer (SSL) is the standard
                                  technology for keeping an internet connection
                                  secure. SSL is using an encryption algorithms
                                  when sending data, which prevents hackers from
                                  reading it.
                                </Tooltip>
                              }
                            >
                              <i className="bi bi-info-circle"></i>
                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                            </OverlayTrigger>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* //THIS IS THE BOX TO THE RIGHT THAT IS ONLY SHOWN ON BIG SCREENS  */}
                  {firstTimeUser === true ? (
                    <div></div>
                  ) : (
                    <div
                      className="box-to-the-right-with-the-overall-results-onsite-scraper"
                      style={{ background: "white" }}
                    >
                      <div className="inner-div-box-to-the-right-with-the-overall-results-onsite-scraper">
                        {metaTitle?.length >= 30 && metaTitle?.length <= 65 ? (
                          <div className="flag-and-title-div-onsite-result-component">
                            {" "}
                            <i
                              style={{
                                color: "#4aac48",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Meta title test </strong>
                              <small>Site passed meta title test</small>
                            </div>
                          </div>
                        ) : (
                          <div className="flag-and-title-div-onsite-result-component">
                            {" "}
                            <i
                              style={{
                                color: "red",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Meta title test </strong>
                              <small>Site did not pass meta title test</small>
                            </div>
                          </div>
                        )}
                        {metaDescription?.length >= 120 &&
                        metaDescription?.length <= 160 ? (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "#4aac48",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Meta description test </strong>
                              <small>Site passed meta description test</small>
                            </div>
                          </div>
                        ) : (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "red",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Meta description test </strong>
                              <small>
                                Site did not pass meta description test
                              </small>
                            </div>
                          </div>
                        )}
                        {h1Length === 1 ? (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "#4aac48",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Heading tags test </strong>
                              <small>Site passed headings test</small>
                            </div>
                          </div>
                        ) : (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "red",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Heading tags test </strong>
                              <small>Site did not pass headings test</small>
                            </div>
                          </div>
                        )}
                        {numberOfEmptyAltTexts < 1 ? (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "#4aac48",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Image Alt text test </strong>
                              <small>Site passed image Alt text test</small>
                            </div>
                          </div>
                        ) : numberOfEmptyAltTexts < 5 ? (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "#a1a102",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Image Alt text test </strong>
                              <small>
                                Site has some small issues regarding image Alt
                                texts
                              </small>
                            </div>
                          </div>
                        ) : (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "red",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Image Alt text test </strong>
                              <small>
                                Site did not pass the image Alt texts test
                              </small>
                            </div>
                          </div>
                        )}
                        {robotsTXTExists === true ? (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "#4aac48",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Robots.txt test </strong>
                              <small>Site passed the Robots.txt test</small>
                            </div>
                          </div>
                        ) : (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "red",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Robots.txt test </strong>
                              <small>
                                Site did not pass the Robots.txt test
                              </small>
                            </div>
                          </div>
                        )}
                        {faviconFromWebsite?.length > 1 ? (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "#4aac48",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Favicon test </strong>
                              <small>Site passed the favicon test</small>
                            </div>
                          </div>
                        ) : (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "red",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>Favicon test </strong>
                              <small>Site did not pass the favicon test</small>
                            </div>
                          </div>
                        )}
                        {isHttpsSupported === true ? (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "#4aac48",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>HTTPS test </strong>
                              <small>Site passed the HTTPS test</small>
                            </div>
                          </div>
                        ) : (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "red",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>HTTPS test </strong>
                              <small>Site did not pass the HTTPS test</small>
                            </div>
                          </div>
                        )}
                        {sslInfo?.valid === true ? (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "#4aac48",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>SSL test </strong>
                              <small>Site passed the SSL test</small>
                            </div>
                          </div>
                        ) : (
                          <div className="flag-and-title-div-onsite-result-component mt-2">
                            {" "}
                            <i
                              style={{
                                color: "red",
                                fontSize: "1.5em",
                                paddingRight: "0.5em",
                              }}
                              className="bi bi-flag"
                            ></i>
                            <div className="meta-title-test-and-overall-recommendation-div">
                              <strong>SSL test </strong>
                              <small>Site did not pass the SSL test</small>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            </Container>
          </Content>
          {/* <Footer
        style={{
          textAlign: "center",
        }}
      >
        SerpMaze
      </Footer> */}
        </Layout>
      )}
    </Layout>
  );
};

export default ReportPageFromInsideApp;
